<template>
  <div>

    <z-centralized-toolbar>

      <v-toolbar-items>
        <v-btn id="btn-adicionar" text small color="primary" @click="adicionar">
          <v-icon left>mdi-cash-usd-outline</v-icon>Adicionar
        </v-btn>

        <v-btn text id="btn-atualizar" @click="refresh" :loading="$store.state.loading">
          <v-icon>mdi-refresh</v-icon>
          <v-tooltip bottom activator="#btn-atualizar">
            Atualizar
          </v-tooltip>
        </v-btn>
      </v-toolbar-items>

      <!-- <v-spacer></v-spacer> -->

      <z-text-field-search
        v-model="busca"
        select
        class="ml-5"
        @keydown.enter="buscar"
        @click:clear="limparBusca"
      ></z-text-field-search>
    </z-centralized-toolbar>

    <v-divider></v-divider>

    <z-scroll-layout :top-position="$v.TOP_POSITION">
      <z-container>

        <z-cabecalho>{{$store.state.titulo_tela}}</z-cabecalho>

        <v-card>
          <v-data-table
          mobile-breakpoint="0"
            :options.sync="paginacao"
            :server-items-length="total_itens"
            :footer-props="$v.FOOTER_PROPS"
            :headers="headers"
            :items="formaspagamento"
            item-key="id"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.descricao }}</td>
                <td class="text-center">
                  <v-btn icon @click="editar(item)" class="ma-0">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon @click="perguntarExcluir(item)" class="ma-0">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>

      </z-container>
    </z-scroll-layout>

    <z-dialogo-sim-nao ref="dialogoRemover" titulo="Remover forma de pagamento?" botaoSim="Remover" botaoNao="Cancelar" :loading="excluindo">
      A forma de pagamento selecionada será removida do sistema.
    </z-dialogo-sim-nao>

    <v-form v-model="form_valido" lazy-validation ref="formulario">
      <z-dialogo ref="dialogoAdicionar" largura="600px" titulo="Forma de Pagamento" dividers persistent @fechar="$refs.formulario.resetValidation()">

          <template v-slot:conteudo>
            <v-row dense>
              <v-col cols="12">
                <z-text-field caps="upper" v-model="formapagamento.descricao" ref="descricao" label="Descrição" placeholder=" " :rules="[regras.campoObrigatorio]"></z-text-field>
              </v-col>
            </v-row>
          </template>

          <template v-slot:actions_right>
            <v-btn text @click="$refs.dialogoAdicionar.fechar()" :disabled="salvando">Cancelar</v-btn>
            <v-btn color="primary" ref="btnConfirmar" @click="confirmar" :loading="salvando" :disabled="!form_valido">Confirmar</v-btn>
          </template>
      </z-dialogo>
    </v-form>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";

import * as regras from '@/app/helpers/validacoes';

export default {
  name: 'FormasPagamentoLista',

  inject: ['notifications'],

  data() {
    return {
      headers: [
        { text: "Código", value: "id", width: "150px" },
        { text: "Descrição", value: "descricao" },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false },
      ],
      excluindo: false,
      salvando: false,
      form_valido: true,
      regras: {...regras}
    };
  },

  computed: {
    ...mapState(['loading']),
    ...mapState('formaspagamento', ['formaspagamento', 'formapagamento', 'total_itens']),

    busca: {
      get () {
        return this.$store.state.formaspagamento.busca
      },
      set (busca) {
        this.$store.commit('formaspagamento/SET_BUSCA', busca);
      }
    },

    paginacao: {
      get () {
        return this.$store.state.formaspagamento.paginacao
      },
      set (paginacao) {
        this.$store.commit('formaspagamento/UPDATE_PAGINACAO', paginacao);
      }
    },
  },

  created() {
    this.refresh();
  },

  mounted() {
    this.setTitulo("Formas de Pagamento");
  },

  methods: {
    ...mapMutations(["setTitulo", 'LOADING_OFF']),
    ...mapActions("formaspagamento", ["listar", "excluir", "abrir", "atualizar", "salvar"]),

    async refresh() {
      try {
        await this.listar();
      } catch (error) {
        console.log(error);
        this.notifications.notificar("Não foi possível listar as formas de pagamento.");
      }
    },

    buscar() {
      this.$store.commit('formaspagamento/SET_PAGE', 1);
      this.refresh();
    },

    limparBusca() {
      this.busca = null;
      this.$store.commit('formaspagamento/SET_PAGE', 1);
      this.refresh();
    },

    adicionar() {
      this.$store.commit('formaspagamento/ZERAR');
      this.$refs.dialogoAdicionar.abrir();
    },

    async editar(formapagamento) {
      try {

        await this.abrir(formapagamento.id);
        this.$refs.dialogoAdicionar.abrir();

      } catch (error) {
        console.log(error);
        this.notifications.notificar("Não foi possível abrir a forma de pagamento selecionada.");
      } finally {
        this.LOADING_OFF();
      }
    },

    async confirmar() {
      if (!this.$refs.formulario.validate()) {
        return false;
      }

      try {
        this.salvando = true;

        if (this.formapagamento.id) {
          await this.atualizar(this.formapagamento);
        } else {
          await this.salvar(this.formapagamento);
        }

        this.$refs.dialogoAdicionar.fechar();
        this.notifications.notificar("Prazo salvo com sucesso");
      } catch(error) {
        this.notifications.notificarErro('Não foi possível salvar esta forma de pagamento. Verifique os dados preenchidos.', error);
        throw error;
      } finally {
          this.salvando = false;
      }
    },

    perguntarExcluir(formapagamento) {
      this.$refs.dialogoRemover.abrir()
        .then(async response => {
          if (response == true) {
            await this.confirmarExcluir(formapagamento);
            this.$refs.dialogoRemover.fechar();
          }
        })
    },

    async confirmarExcluir(formapagamento) {
      try {
        this.excluindo = true;
        await this.excluir(formapagamento.id);
        this.notifications.notificar("Prazo excluído com sucesso!");
      } catch (error) {
        this.notifications.notificar("Não foi possível excluir o forma de pagamento selecionada!");
        throw error;
      } finally {
        this.excluindo = false;
      }
    },
  },

  watch: {
    paginacao: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
</style>
